import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Copy from '../../../atoms/copy/copy';
import EducationStep from '../../../molecules/education/step/educationStep';
import StyledEducationSteps from './educationSteps.style';
import Container from '../../../layout/container/container';
import Headline from '../../../atoms/headline/headline';

function EducationSteps({ headline, copy, steps, educationTopics, educationType }) {
  return (
    <StyledEducationSteps>
      <Container large>
        {headline && (
          <div className="steps__header">
            <Headline className="steps__header-headline" tag="h2" secondary>
              {headline}
            </Headline>
            {copy && <Copy>{copy}</Copy>}
          </div>
        )}
        <div className="steps__grid">
          {steps &&
            steps.map((item, index) => {
              return (
                <EducationStep
                  numberedCard
                  key={item.id}
                  number={index + 1}
                  topics={educationTopics}
                  contentType={educationType}
                  headline={item.headline}
                  copy={item.copy}
                  image={item.stepImage}
                  videoId={item.videoId}
                  previewImage={item.previewImage}
                  hoster={item.hoster}
                />
              );
            })}
        </div>
      </Container>
    </StyledEducationSteps>
  );
}

EducationSteps.propTypes = {
  headline: PropTypes.string,
  copy: PropTypes.string,
  steps: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      headline: PropTypes.string,
      copy: PropTypes.string,
      stepImage: PropTypes.shape({
        src: PropTypes.string,
        alt: PropTypes.string
      })
    })
  ).isRequired,
  educationTopics: PropTypes.arrayOf(PropTypes.shape()),
  educationType: PropTypes.arrayOf(PropTypes.shape())
};

const mapStateToProps = state => ({
  educationTopics: state.app.pageData.educationTopics,
  educationType: state.app.pageData.educationType
});

export default connect(mapStateToProps)(EducationSteps);
